import styled, { createGlobalStyle } from "styled-components"

export const PickerPopupStyle = createGlobalStyle`

 @media screen and (min-width: 450px) {
 .picker-popup {
   .adm-mask,
   .adm-popup-body {
     max-width: var(--app-max-width);
     left: 50%;
     transform: translateX(-50%) !important;
     opacity: !important;
   };
 }
 };
 
 .picker-popup {
   .adm-picker-header-button {
   font-size: 14px;
   font-style: normal;
   font-weight: 700;
   line-height: 14px; /* 100% */
   letter-spacing: 0.14px;
   color: var(--Schemes-Primary, #0DA3BA);
   padding-top:14px;
   padding-left: 20px;
   padding-right:20px;
   }
 
   .adm-picker-view-column-item {
     font-size: 16px;
     font-style: normal;
     font-weight: 600;
     line-height: 160%;
     color: var(--Schemes-On-Primary-Container, #044257);
   }
 
   .adm-picker-view-column-item-active {
     font-size: 20px;
     font-style: normal;
     font-weight: 800;
     line-height: 120%;
     color: var(--Schemes-On-Surface, #1C1F21);
   }
 }
 `
export const PickerHeader = styled.div`
  position: absolute;
  top: 6px;
  width: 36px;
  height: var(--spacing_xxs, 4px);
  border-radius: var(--spacing_l, 16px);
  background: var(--Schemes-Outline-Variant, rgba(0, 38, 58, 0.14));
  transform: translateX(-50%);
  left: 50%;
`
